import { FC, useState } from "react";
import Select from "react-select";
import { APP } from "../../Utils/Constants.ts";

interface PlacesProps {
  datas: Place[];
  handlePlaces: (filterId: string, value: any) => void;
  value: Filter | undefined;
}

function isEmpty(value: any) {
  return (
    value == null ||
    (typeof value === 'string' && value.trim().length === 0) ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'object' && Object.keys(value).length === 0)
  );
}

const Places: FC<PlacesProps> = ({ datas, handlePlaces, value }) => {

  const [menuOpen, setMenuOpen] = useState(false);

  // Native button for removing a selected item with keyboard support
  const MultiValueRemove = (props: any) => {
    const { innerProps, data } = props;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        innerProps.onClick?.(e);
      }
    };

    return (
      <button
        type="button"
        {...innerProps}
        onKeyDown={handleKeyDown}
        aria-label={`Supprimer ${data.label}`}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '0 5px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        ×
      </button>
    );
  };

  // Native button for clearing all selected values with keyboard support
  const ClearIndicator = (props: any) => {
    const { innerProps, clearValue } = props;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        clearValue();
      }
    };

    return (
      <button
        type="button"
        {...innerProps}
        onKeyDown={handleKeyDown}
        aria-label="Vider le champ"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }}
      >
        ×
      </button>
    );
  };

  const getOption = (options: Place[]) => {
    const data: { value: string; label: string }[] = [];

    options.forEach((element: Place) => {
      if (element.slug !== "administration-centrale") {
        data.push({ value: element.slug, label: element.name });
      }
    });

    return data;
  };

  const optionValue = getOption(datas);

  const getSelectedValue = (values: Filter | undefined) => {
    let selectedValues: ({ value: string; label: string } | undefined)[] = [];

    if (!isEmpty(values)) {
      values?.values.forEach((value: string) => {
        const val = optionValue.find((option) => option.value === value);
        selectedValues.push(val);
      });
    }

    return selectedValues;
  };

  const handleChange = (value: any) => {
    handlePlaces(APP.FILTER.PLACES.FIELD, value);
    setMenuOpen(false);
  };

  // Handle keyboard interaction for opening the menu
  // Ignore events coming from internal buttons
  const handleKeyDown = (e: React.KeyboardEvent) => {
    const target = e.target as HTMLElement;

    if (target.closest('button')) return;

    if ((e.key === 'Enter' || e.key === ' ') && !menuOpen) {
      e.preventDefault();
      setMenuOpen(true);
    }
  };

  return (
    <div className="filter-wrapper place-input">
      <label htmlFor="filter-places" className="filter-label">{Drupal.t('Localisation')}</label>

      <Select
        inputId="filter-places"
        isMulti
        value={getSelectedValue(value)}
        placeholder={Drupal.t("Lieu")}
        onChange={handleChange}
        options={optionValue}

        menuIsOpen={menuOpen}
        onMenuOpen={() => setMenuOpen(true)}
        onMenuClose={() => setMenuOpen(false)}
        onKeyDown={handleKeyDown}

        components={{
          MultiValueRemove,
          ClearIndicator
        }}
      />
    </div>
  );
};

export default Places;